import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IInitialState, RootState } from '../../../../reduxService';
import { IPaginatedResponse, IPreviewTemplateResponse } from '../../../api/IApiResponse';
import * as BeMaccaferriStoreHelper from '../../../api/store/BeMaccaferriStoreHelper';
import { EProjectType } from '../../../enum/project';
import { IGetByTypeRequest } from '../../../api/IApiRequest';

const initialState: IInitialState<IPaginatedResponse<IPreviewTemplateResponse>> = {
    initialState: true,
};

export const templateSlice = createSlice({
    name: 'templateMacra2',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchTemplatesByType.pending, state => {
                state.data = undefined;
                state.pending = true;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchTemplatesByType.fulfilled, (state, action) => {
                state.data = action.payload;
                state.pending = false;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchTemplatesByType.rejected, (state, action) => {
                state.data = undefined;
                state.pending = false;
                state.error = {
                    status: (action.payload as any).status,
                    data: (action.payload as any).data,
                };
                state.initialState = false;
            });
    },
});

export const fetchTemplatesByType = createAsyncThunk('api/Template/GetTemplateMacra2ByType', async (request: IGetByTypeRequest, { rejectWithValue }) => {
    try {
        const res = await BeMaccaferriStoreHelper.getTemplatesByTypeAsync(request.type, request.pageNumber, request.pageSize);
        return res.data;
    } catch (error: any) {
        return rejectWithValue(error.response);
    }
});

export const selectTemplate = (state: RootState) => state.macra2.template;

export default templateSlice.reducer;
